import { PREMISES_SET_SUBSCRIBE, PREMISES_SET_DASHBOARD_DISPLAY, PREMISES_SET_COUNTRY_FILTER,  PREMISES_SET_REGION_FILTER} from '../premises';
import { LocationFilterLevel } from '../geo';
import { DISMISS_MESSAGE, DISMISS_ALL_MESSAGES } from '../feedback';
import {CABINETS_LOADING, SENSORS_LOADING} from "../cabinets";

export function ui(state, action) {
    switch (action.type) {
        case DISMISS_MESSAGE:
            return Object.assign({}, state, {messages:
                state.messages.filter((_, i) => i !== action.index)});
        case DISMISS_ALL_MESSAGES:
            return Object.assign({}, state, {messages: state.messages.filter((_, i) => i === -1)});
        case CABINETS_LOADING:
            return Object.assign({}, state, {premisesUnits: {loading: action.to}});
        case SENSORS_LOADING:
            let newstate = state;
            if (action.details){
                newstate.sensors.readingsLoading = action.to;
            } else if (action.unit) {
                newstate.sensors.individualSensorsLoading[action.unit] = action.to;
            }else {
                newstate = {sensors:{individualSensorsLoading:{}}}
            }
            return Object.assign({}, state, newstate);
        default:
            return Object.assign({}, state,
                {premises: premises(state.premises, action)}
            );
    }
}

function premises(state, action) {
    switch (action.type) {
        case PREMISES_SET_SUBSCRIBE:
            return Object.assign({}, state, {[action.id]: {isSubscribing: false}});
        case PREMISES_SET_DASHBOARD_DISPLAY:
            return Object.assign({}, state, {[action.id]: {settingDashboardDisplay: false}});
        case PREMISES_SET_COUNTRY_FILTER:
            return Object.assign({}, state, {selectedCountry: action.id});
        case PREMISES_SET_REGION_FILTER:
            return Object.assign({}, state, {selectedRegion: action.id});
        default:
            return state;
    }
}
